module.exports = __webpack_public_path__ + "img/vip-coupon.4f0416bf.png";